<template>
  <div class="scroll-vertical dashboard-container">
    <tiles v-for="(row,i) in rows" :key="i">
      <div v-for="obj in row" :key="obj.id" class="tile is-parent is-6">
        <tile-action :action="obj"></tile-action>
      </div>
    </tiles>
  </div>
</template>

<script>
import _ from 'lodash';
import Tiles from '@/components/Tiles.vue';
import TileAction from '@/components/actions/tiles/TileAction.vue';

export default {
  name: 'ActionsTiles',
  components: { Tiles, TileAction },
  props: {
    actions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      columns: 2,
    };
  },
  computed: {
    rows() {
      return _.chunk(this.actions, this.columns);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/colors.scss';

</style>
